import { styled, Typography } from "@mui/material";
import SignedByIcon from "assets/icons/chequeDrawer/SignedByIcon";
import { PriceComponent } from "components/Shared/Dashboard/styled";
import { formatPrice } from "helpers/dataFormat";
import { Tag } from "./components";

const PassedChequContainer = styled("div")(({ theme }) => ({
  height: "200px",
  backgroundImage: 'url("/assets/images/passedCheckBackground.svg")',
  backgroundSize: "100% 118%",
  backgroundRepeat: "no-repeat",
  backgroundPositionX: 0,
  backgroundPositionY: "-15px",
  padding: "22px 16px 14px 114px",
}));
const DetailsContainer = styled("div")(({ theme }) => ({
  width: "100%",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  padding: "19px 16px",
}));

const ChequeUpperDetails = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  height: "28px",
}));
const ChequeMainDetails = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
  height: "68px",
}));

const SignedBy = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  height: "32px",
  width: "194px",
}));

const PassedCheque = ({ cheque }: { cheque: any }) => {
  return (
    <div>
      <PassedChequContainer>
        <DetailsContainer>
          <ChequeUpperDetails>
            <Tag>
              <Typography variant="body2" color="primary">
                # {cheque?.number}
              </Typography>
            </Tag>
            <Typography variant="body2" color="text.secondary">
              {cheque?.createdAt}
            </Typography>
          </ChequeUpperDetails>
          <ChequeMainDetails>
            <PriceComponent
              price={formatPrice(cheque?.amount)}
              variant="h5"
              currency={cheque?.Currency?.fa_title}
            />
            <SignedBy>
              <SignedByIcon />
              <Typography variant="body2">{cheque?.payer}</Typography>
            </SignedBy>
          </ChequeMainDetails>
        </DetailsContainer>
      </PassedChequContainer>
    </div>
  );
};

export default PassedCheque;
